import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

export const availableLanguages = ["nl", "fr", "de", "en"];

const supportedLanguages = ["nl", "fr", "de", "en"];

let fallbackLng = "nl";
try {
    const cachedFallback = sessionStorage.getItem("fallbackLng");
    if (cachedFallback) {
        fallbackLng = cachedFallback;
    } else {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", `/i18nConfig.json?v=${new Date().getTime()}`, false); // false = synchroon
        xhr.send();

        if (xhr.status === 200) {
            const config = JSON.parse(xhr.responseText);
            if (config.fallbackLng) {
                fallbackLng = config.fallbackLng;
                sessionStorage.setItem("fallbackLng", fallbackLng);
            }
        }
    }
} catch (e) {
    console.warn("Could not load i18nConfig.json synchronously, using default fallback");
}

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: supportedLanguages,
        fallbackLng,
        interpolation: {
            escapeValue: false,
        },
        cleanCode: true,
        ns: ["common"],
        defaultNS: "common",
        detection: {
            order: ["path", "localStorage", "navigator"],
            lookupFromPathIndex: 0,
        },
        backend: {
            loadPath: "/i18n/{{lng}}.json?v=" + new Date().getTime(),
            parse: (data: string) => {
                const parsed = JSON.parse(data);
                // De JSON bestanden hebben een "common" wrapper, extraheer deze
                return parsed.common || parsed;
            },
        },
    });

fetch(`/i18nConfig.json?v=${new Date().getTime()}`)
    .then(response => response.json())
    .then(config => {
        if (config.fallbackLng) {
            sessionStorage.setItem("fallbackLng", config.fallbackLng);
            i18n.options.fallbackLng = config.fallbackLng;

            const pathMatch = window.location.pathname.match(/^\/([a-z]{2})\//);
            const pathLang = pathMatch ? pathMatch[1] : null;

            if (pathLang && supportedLanguages.includes(pathLang)) {
                if (i18n.language !== pathLang) {
                    localStorage.setItem("i18nextLng", pathLang);
                    i18n.changeLanguage(pathLang);
                }
            }
            else if (i18n.language !== config.fallbackLng) {
                localStorage.setItem("i18nextLng", config.fallbackLng);
                i18n.changeLanguage(config.fallbackLng);
            }
        }
    })
    .catch(() => {
        console.warn("Could not load i18nConfig.json, using default fallback language");
    });

export default i18n;
